import { createRoot } from 'react-dom/client';
import RetailerRegistrationApp from './RetailerRegistrationApp';

// Initialize React app
const container = document.getElementById('registration-root');
if (container) {
    // Read data attributes from container
    const returnUrl = container.dataset.returnUrl || '/';

    const root = createRoot(container);

    root.render(<RetailerRegistrationApp returnUrl={returnUrl} />);
}
